var _rect, _rect2, _rect3, _g, _circle, _circle2, _g2, _g3, _rect4, _g4, _circle3, _circle4, _g5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDisconnectedAssignedDevicesRed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 52,
    fill: "#ACACAC"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_86_56220)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1050,
    transform: "translate(-807 -100)",
    fill: "#F4F7FA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 2,
    width: 52.4507,
    height: 51.8678,
    rx: 25.9339,
    fill: "#EBEFF2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_86_56220)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.1039 38C42.0976 38 42.9032 36.8748 42.9032 35.4868C42.9032 34.0988 42.0976 32.9736 41.1039 32.9736C40.1102 32.9736 39.3047 34.0988 39.3047 35.4868C39.3047 36.8748 40.1102 38 41.1039 38Z",
    fill: "#CA0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.025 38C33.8238 38 33.6225 37.9008 33.4687 37.7024C33.2319 37.4048 33.1846 37.0576 33.1846 36.8096C33.1846 36.5119 33.2556 36.2474 33.3976 36.0325L49.0345 11.3968C49.2002 11.1488 49.4369 11 49.6737 11C49.8749 11 50.0761 11.0992 50.23 11.2976C50.5851 11.7275 50.6206 12.4715 50.301 12.9841L34.6642 37.5866C34.4985 37.8512 34.2736 37.9835 34.025 37.9835V38Z",
    fill: "#CA0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1224 30.3447C45.0571 28.8567 43.7077 27.9142 42.2398 27.6001L41.0088 29.5346C42.4884 29.5015 43.9681 30.2621 45.0926 31.8328C45.2228 32.0312 45.4122 32.1304 45.6134 32.1304C45.8147 32.1304 45.9922 32.0147 46.1343 31.8328V31.7997C46.4184 31.4029 46.4184 30.7746 46.1343 30.3778H46.1224V30.3447Z",
    fill: "#CA0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7468 27.1867H32.7705V27.2033C33.0546 27.5835 33.5044 27.567 33.7885 27.1867V27.1537C35.6469 24.5909 38.0025 23.2186 40.4054 23.0036L41.7075 20.9534C41.5063 20.9534 41.305 20.9038 41.092 20.9038C37.9551 20.9038 35.0077 22.5903 32.7823 25.6656H32.7705C32.7705 25.6656 32.7468 25.7152 32.7468 25.7317L32.6994 25.7979C32.4509 26.1947 32.4627 26.8064 32.735 27.1867H32.7468Z",
    fill: "#CA0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4486 25.698C48.3477 24.1769 47.0693 22.9864 45.6844 22.1763L44.6309 23.8297C46.0158 24.5241 47.3179 25.6319 48.4187 27.1861C48.5489 27.3845 48.7383 27.4837 48.9396 27.4837C49.1408 27.4837 49.3184 27.3679 49.4604 27.1861V27.153C49.7445 26.7562 49.7445 26.1279 49.4604 25.7311H49.4486V25.698Z",
    fill: "#CA0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7871 21.0862H52.7634V21.0697C51.5915 19.4493 50.3013 18.1266 48.9163 17.085L47.9102 18.6722C49.2951 19.6477 50.5853 20.9374 51.7454 22.5412C51.8874 22.7396 52.065 22.8388 52.2662 22.8388C52.4674 22.8388 52.6332 22.7396 52.7634 22.5577H52.7871C53.0711 22.1278 53.0711 21.483 52.7871 21.0862Z",
    fill: "#CA0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2882 16.886L45.3891 15.15C39.873 13.0832 33.7413 15.0508 29.4208 21.0857L29.2432 21.5156C29.1604 21.8793 29.2432 22.2761 29.4208 22.5407H29.4445V22.5572C29.7285 22.9375 30.1784 22.921 30.4624 22.5407C34.2148 17.3159 39.4587 15.4311 44.2882 16.886Z",
    fill: "#CA0000"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 33,
    r: 6.5,
    fill: "#FDEDE9",
    stroke: "#CC3311"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_86_56220",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 39,
    y: 26,
    width: 14,
    height: 14
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 33,
    r: 6.5,
    fill: "#FFAD0D",
    stroke: "#252525"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_86_56220)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.9998 29.5C46.3864 29.5 46.6998 29.8656 46.6998 30.3167V33.5833C46.6998 34.0344 46.3864 34.4 45.9998 34.4C45.6132 34.4 45.2998 34.0344 45.2998 33.5833V30.3167C45.2998 29.8656 45.6132 29.5 45.9998 29.5Z",
    fill: "#CC3311"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.6998 35.8001C46.6998 35.4135 46.3864 35.1001 45.9998 35.1001C45.6132 35.1001 45.2998 35.4135 45.2998 35.8001C45.2998 36.1867 45.6132 36.5001 45.9998 36.5001C46.3864 36.5001 46.6998 36.1867 46.6998 35.8001Z",
    fill: "#CC3311"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_86_56220)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -776,
    y: -20,
    width: 1521,
    height: 91,
    rx: 9.94788,
    fill: "#FEFEFF"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 52.4507,
    height: 51.8678,
    rx: 25.9339,
    fill: "#EBEFF2"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_86_56220)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.2486 36.0002C27.4808 36.0002 28.4797 34.9584 28.4797 33.6732C28.4797 32.388 27.4808 31.3462 26.2486 31.3462C25.0165 31.3462 24.0176 32.388 24.0176 33.6732C24.0176 34.9584 25.0165 36.0002 26.2486 36.0002Z",
    fill: "#CA0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4709 36C17.2213 36 16.9718 35.9081 16.781 35.7244C16.4874 35.4489 16.4287 35.1274 16.4287 34.8977C16.4287 34.6222 16.5168 34.3772 16.6929 34.1782L36.0826 11.3674C36.2881 11.1378 36.5816 11 36.8752 11C37.1247 11 37.3743 11.0919 37.5651 11.2756C38.0054 11.6736 38.0494 12.3625 37.6531 12.8371L18.2635 35.6173C18.058 35.8622 17.7791 35.9847 17.4709 35.9847V36Z",
    fill: "#CA0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4718 28.9119C31.1507 27.5341 29.4775 26.6615 27.6574 26.3706L26.1309 28.1618C27.9656 28.1312 29.8004 28.8354 31.1948 30.2898C31.3562 30.4735 31.5911 30.5653 31.8406 30.5653C32.0901 30.5653 32.3103 30.4582 32.4864 30.2898V30.2592C32.8387 29.8917 32.8387 29.31 32.4864 28.9426H32.4718V28.9119Z",
    fill: "#CA0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8858 25.9879H15.9152V26.0032C16.2675 26.3553 16.8252 26.34 17.1775 25.9879V25.9573C19.4819 23.5844 22.4029 22.3137 25.3825 22.1147L26.9971 20.2163C26.7476 20.2163 26.498 20.1704 26.2338 20.1704C22.3442 20.1704 18.6893 21.732 15.9299 24.5795H15.9152C15.9152 24.5795 15.8858 24.6254 15.8858 24.6407L15.8271 24.7019C15.5189 25.0694 15.5336 25.6358 15.8712 25.9879H15.8858Z",
    fill: "#CA0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.597 24.6095C35.2319 23.2011 33.6467 22.0988 31.9294 21.3486L30.623 22.8796C32.3404 23.5225 33.955 24.5483 35.32 25.9873C35.4815 26.171 35.7163 26.2629 35.9659 26.2629C36.2154 26.2629 36.4355 26.1557 36.6117 25.9873V25.9567C36.964 25.5893 36.964 25.0075 36.6117 24.6401H36.597V24.6095Z",
    fill: "#CA0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7358 20.3396H40.7065V20.3243C39.2533 18.824 37.6534 17.5992 35.9361 16.6348L34.6885 18.1045C36.4058 19.0077 38.0057 20.2018 39.4442 21.6868C39.6203 21.8705 39.8405 21.9624 40.09 21.9624C40.3395 21.9624 40.545 21.8705 40.7065 21.7021H40.7358C41.0881 21.3041 41.0881 20.707 40.7358 20.3396V20.3396Z",
    fill: "#CA0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1968 16.4501L31.5618 14.8427C24.7219 12.929 17.1187 14.7508 11.7612 20.3387L11.541 20.7367C11.4383 21.0735 11.541 21.4409 11.7612 21.6859H11.7905V21.7012C12.1428 22.0533 12.7006 22.038 13.0528 21.6859C17.7058 16.8482 24.2081 15.1029 30.1968 16.4501V16.4501Z",
    fill: "#CA0000"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 35,
    r: 6.5,
    fill: "#F9D7D7",
    stroke: "#CA0000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_86_56220",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 28,
    width: 14,
    height: 14
  }, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 35,
    r: 6.5,
    fill: "#FFAD0D",
    stroke: "#252525"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_86_56220)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9998 31.5C32.3864 31.5 32.6998 31.8656 32.6998 32.3167V35.5833C32.6998 36.0344 32.3864 36.4 31.9998 36.4C31.6132 36.4 31.2998 36.0344 31.2998 35.5833V32.3167C31.2998 31.8656 31.6132 31.5 31.9998 31.5Z",
    fill: "#CA0000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.6998 37.8001C32.6998 37.4135 32.3864 37.1001 31.9998 37.1001C31.6132 37.1001 31.2998 37.4135 31.2998 37.8001C31.2998 38.1867 31.6132 38.5001 31.9998 38.5001C32.3864 38.5001 32.6998 38.1867 32.6998 37.8001Z",
    fill: "#CA0000"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_86_56220",
    x: -778,
    y: -20,
    width: 1525,
    height: 96,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.307813 0 0 0 0 0.326577 0 0 0 0 0.375 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_86_56220"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_86_56220",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_86_56220"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1050,
    fill: "white",
    transform: "translate(-807 -100)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_86_56220"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 27,
    fill: "white",
    transform: "translate(28 11)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_86_56220"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 25,
    fill: "white",
    transform: "translate(10 11)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisconnectedAssignedDevicesRed);
export default __webpack_public_path__ + "static/media/disconnected-assigned-devices-red.14449e10ea8920815d004673709914f6.svg";
export { ForwardRef as ReactComponent };